import { useTracking } from '@dh-io-emh/shared/src/composables/tracking.composable';
import { getProductsDataTrackingObject } from '@dh-io-emh/shared/src/tracking/tracking.utils';
import { PriceType } from '@dh-io-emh/shared/src/types/price.type';
import { Ref } from 'vue';
import { IProductFilterType } from '@dh-io-emh/shared/src/models/product-filter/product-filter.model';
import { useTrackingFilterQueryString } from '@dh-io-emh/shared/src/composables/tracking-filter-query-string.composable';
import { DealerInfo, LocationFilterParams } from '@dh-io-emh/shared/src/stores/products/products.connection';
import Vehicle from '@dh-io-emh/shared/src/models/vehicle.model';

export const useSrpTracking = (
  selectedFilters: Ref<IProductFilterType[]>,
  selectedTab: Ref<'vans' | 'cars'>,
  searchResults: Ref<Vehicle[]>,
  locationFilterParams: Ref<LocationFilterParams | null>,
  dealerFilterInfo: Ref<DealerInfo | null>,
) => {
  const { trackLinkClickOnce, trackPageView } = useTracking();
  const { createQueryStringFilterValue } = useTrackingFilterQueryString(locationFilterParams, dealerFilterInfo);

  const trackPopoverOpen = (type: PriceType) => {
    trackLinkClickOnce(type, {
      eventDetail: {
        category: 'feature',
        action: 'price_tooltip',
        label: type,
      },
    });
  };

  const trackTagExpand = () => {
    const eventDetail = {
      category: 'feature',
      action: 'campaign_tag',
      label: 'expand',
    };

    trackLinkClickOnce('expand', { eventDetail });
  };

  const trackTagModalOpen = () => {
    const eventDetail = {
      category: 'feature',
      action: 'campaign_tag',
      label: 'view_details',
    };

    trackLinkClickOnce('modal-open', { eventDetail });
  };

  const trackingPageView = () => {
    const queryStringFilters = createQueryStringFilterValue(selectedFilters.value);

    trackPageView({
      page: {
        name: `product_list.${selectedTab.value}`,
        type: 'product_list',
        filter: queryStringFilters as any,
        products: getProductsDataTrackingObject(searchResults.value),
      },
    });
  };

  return {
    trackPopoverOpen,
    trackTagExpand,
    trackTagModalOpen,
    trackingPageView,
  };
};
